/* eslint-disable import/prefer-default-export */
import { createSelector } from 'reselect';

import { RootState } from 'redux/schemas';
import { MentoringProgramGoalItem } from 'redux/schemas/models/mentoring-program-goal-items';

export const getMentoringProgramGoalItemsList = (enrollmentId: number) => createSelector(
  (state: RootState) => state.models.mentorshipProgramGoalItems[enrollmentId],
  (state, ids: number[]) => ids,
  (
    mentorshipProgramGoalItems: Record<number, MentoringProgramGoalItem>,
    ids: number[],
  ) => ids.map((id) => mentorshipProgramGoalItems[id]),
);

export const getMentoringProgramGoalItems = (enrollmentId: number) => (state: RootState) => state.models.mentorshipProgramGoalItems[enrollmentId];

export const getMentoringProgramGoals = (enrollmentId: number) => (state: RootState) => Object.values(state.models.mentorshipProgramGoalItems[enrollmentId]?.goals || {});

export const getMentoringProgramGoalVideoPlayStatus = (state: RootState) => state.app.mentoringProgram.goals.playVideo;
